import './FormSubmittedPage.scss';
import "../../i18n";
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import CheckmarkAnimation from '../../Components/Animations/Checkmark/Checkmark';
import ReturnHomeButton from '../../Components/Buttons/HomeButton/ReturnHomeButton';

export const FormSubmittedPage = () => {
    const { t } = useTranslation();
    
    /*
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const submitted = params.get('submitted');
  
      if (submitted === 'true') {
        setAllowed(true);
      } else {
        navigate('/');
      }
    }, []);
  
    if (!allowed) return null;
    */
  

    return (
        <div className="form-submitted-container">

            <div>
                <CheckmarkAnimation />
            </div>
            <motion.h1
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.5, duration: 1.5 }}
                className="thank-you-text"
            >
                {t("contact.form.confirmationMessage")}
            </motion.h1>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2.5, duration: 1.5 }}
            >
                <ReturnHomeButton />
            </motion.div>
        </div>
    );
}

export default FormSubmittedPage;